/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Genres_HeadingInputs */

const id_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const ms_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const da_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genrer`)
};

const de_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const en_us2_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const es_es2_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros`)
};

const es_mx2_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros`)
};

const fil_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Genre`)
};

const fr_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const it_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generi`)
};

const hu_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Műfajok`)
};

const nl_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const no_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjangre`)
};

const pl_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gatunki`)
};

const pt_br2_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gêneros`)
};

const pt_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros`)
};

const ro_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genuri`)
};

const fi_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lajityypit`)
};

const sv_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genrer`)
};

const vi_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thể loại`)
};

const tr_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türler`)
};

const cs_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žánry`)
};

const bg_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанрове`)
};

const ru_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанры`)
};

const uk_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанри`)
};

const ar_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأنواع`)
};

const hi_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शैलियाँ`)
};

const th_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แนวเกม`)
};

const ja_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジャンル`)
};

const zh_cn2_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

const zh_hant1_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`類型`)
};

const ko_genres_heading = /** @type {(inputs: Genres_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`장르`)
};

/**
* | output |
* | --- |
* | "Genres" |
*
* @param {Genres_HeadingInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const genres_heading = /** @type {((inputs?: Genres_HeadingInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Genres_HeadingInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_genres_heading(inputs)
	if (locale === "ms") return ms_genres_heading(inputs)
	if (locale === "da") return da_genres_heading(inputs)
	if (locale === "de") return de_genres_heading(inputs)
	if (locale === "en-US") return en_us2_genres_heading(inputs)
	if (locale === "es-ES") return es_es2_genres_heading(inputs)
	if (locale === "es-MX") return es_mx2_genres_heading(inputs)
	if (locale === "fil") return fil_genres_heading(inputs)
	if (locale === "fr") return fr_genres_heading(inputs)
	if (locale === "it") return it_genres_heading(inputs)
	if (locale === "hu") return hu_genres_heading(inputs)
	if (locale === "nl") return nl_genres_heading(inputs)
	if (locale === "no") return no_genres_heading(inputs)
	if (locale === "pl") return pl_genres_heading(inputs)
	if (locale === "pt-BR") return pt_br2_genres_heading(inputs)
	if (locale === "pt") return pt_genres_heading(inputs)
	if (locale === "ro") return ro_genres_heading(inputs)
	if (locale === "fi") return fi_genres_heading(inputs)
	if (locale === "sv") return sv_genres_heading(inputs)
	if (locale === "vi") return vi_genres_heading(inputs)
	if (locale === "tr") return tr_genres_heading(inputs)
	if (locale === "cs") return cs_genres_heading(inputs)
	if (locale === "bg") return bg_genres_heading(inputs)
	if (locale === "ru") return ru_genres_heading(inputs)
	if (locale === "uk") return uk_genres_heading(inputs)
	if (locale === "ar") return ar_genres_heading(inputs)
	if (locale === "hi") return hi_genres_heading(inputs)
	if (locale === "th") return th_genres_heading(inputs)
	if (locale === "ja") return ja_genres_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_genres_heading(inputs)
	if (locale === "zh-Hant") return zh_hant1_genres_heading(inputs)
	return ko_genres_heading(inputs)
});
export { genres_heading as "genres.heading" }